/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PGARecentHistoryTable_query$ref = any;
export type PGARecentHistoryQueryVariables = {|
  playerId: string,
  count?: ?number,
|};
export type PGARecentHistoryQueryResponse = {|
  +$fragmentRefs: PGARecentHistoryTable_query$ref
|};
export type PGARecentHistoryQuery = {|
  variables: PGARecentHistoryQueryVariables,
  response: PGARecentHistoryQueryResponse,
|};
*/


/*
query PGARecentHistoryQuery(
  $playerId: ID!
  $count: Int
) {
  ...PGARecentHistoryTable_query_2z5jLm
}

fragment PGARecentHistoryTable_query_2z5jLm on Query {
  pgaRecentHistoryForDkPlayer(dkPlayerId: $playerId, first: $count) {
    edges {
      node {
        id
        strokesGainedApproachTheGreen
        strokesGainedAroundTheGreen
        strokesGainedBallStriking
        strokesGainedIronPlay
        strokesGainedOffTheTee
        strokesGainedPutting
        strokesGainedShortGame
        strokesGainedTeeToGreen
        strokesGainedTotal
        goodDriveRatio
        currentPosition
        dkScore
        eventToPar
        event {
          startDate
          shortEndDate
          tournament {
            officialName
            id
          }
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "playerId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "dkPlayerId",
    "variableName": "playerId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PGARecentHistoryQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "playerId",
            "variableName": "playerId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "PGARecentHistoryTable_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PGARecentHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PGATourEventPlayerTypeConnection",
        "kind": "LinkedField",
        "name": "pgaRecentHistoryForDkPlayer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourEventPlayerTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventPlayerType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "strokesGainedApproachTheGreen",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "strokesGainedAroundTheGreen",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "strokesGainedBallStriking",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "strokesGainedIronPlay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "strokesGainedOffTheTee",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "strokesGainedPutting",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "strokesGainedShortGame",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "strokesGainedTeeToGreen",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "strokesGainedTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "goodDriveRatio",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentPosition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dkScore",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventToPar",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PGATourEventType",
                    "kind": "LinkedField",
                    "name": "event",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shortEndDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PGATourTournamentType",
                        "kind": "LinkedField",
                        "name": "tournament",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "officialName",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "dkPlayerId"
        ],
        "handle": "connection",
        "key": "PGARecentHistoryTable_pgaRecentHistoryForDkPlayer",
        "kind": "LinkedHandle",
        "name": "pgaRecentHistoryForDkPlayer"
      }
    ]
  },
  "params": {
    "cacheID": "265c2e64fc8162c2d2adeb758013b355",
    "id": null,
    "metadata": {},
    "name": "PGARecentHistoryQuery",
    "operationKind": "query",
    "text": "query PGARecentHistoryQuery(\n  $playerId: ID!\n  $count: Int\n) {\n  ...PGARecentHistoryTable_query_2z5jLm\n}\n\nfragment PGARecentHistoryTable_query_2z5jLm on Query {\n  pgaRecentHistoryForDkPlayer(dkPlayerId: $playerId, first: $count) {\n    edges {\n      node {\n        id\n        strokesGainedApproachTheGreen\n        strokesGainedAroundTheGreen\n        strokesGainedBallStriking\n        strokesGainedIronPlay\n        strokesGainedOffTheTee\n        strokesGainedPutting\n        strokesGainedShortGame\n        strokesGainedTeeToGreen\n        strokesGainedTotal\n        goodDriveRatio\n        currentPosition\n        dkScore\n        eventToPar\n        event {\n          startDate\n          shortEndDate\n          tournament {\n            officialName\n            id\n          }\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ddf343da5d3e6336ca53a734129ce2f0';

module.exports = node;
